
import React, { useState, useEffect } from "react";
import "../styles.scss";

interface RandomImageProps {
  desktopImageSet: string[];
  mobileImageSet: string[];
}

const RandomImage: React.FC<RandomImageProps> = ({
  desktopImageSet,
  mobileImageSet,
}) => {
  const [selectedDesktopImage, setSelectedDesktopImage] = useState("");
  const [selectedMobileImage, setSelectedMobileImage] = useState("");

  useEffect(() => {
    const getNextImageIndex = (imageArray, key) => {
      if (!imageArray || !Array.isArray(imageArray) || imageArray.length === 0) return "";
    
    const lastIndexStr = localStorage.getItem(key);
    let lastIndex = lastIndexStr ? parseInt(lastIndexStr, 10): -1;

    const nextIndex = (lastIndex + 1) % imageArray.length;

    localStorage.setItem(key, nextIndex.toString());

    return imageArray[nextIndex];
    };

    setSelectedDesktopImage(getNextImageIndex(desktopImageSet, 'desktop-image-index'));
    setSelectedMobileImage(getNextImageIndex(mobileImageSet, 'mobile-image-index'));
  }, [desktopImageSet, mobileImageSet]);

  return (
    <picture className="hero-bg">
      <source media="(min-width: 600px)" srcSet={selectedDesktopImage} />
      <img
        src={selectedMobileImage}
        alt="Turn the corner, less indolent systemic mastocytosis symptom burden"
      />
    </picture>
  );
};

export default RandomImage;